export const Fact = () => (
  <section id="funFacts" className="container my-5">
    <div className="row d-flex align-items-center">
      <div className="col-12 col-md-6 p-4">
        <span style={{ color: '#00FF00', textTransform: 'uppercase', letterSpacing: '2px' }}>Development Stats</span>
        <h1
          className="text-white mb-3 mt-4"
          style={{ fontSize: 50, fontWeight: 600 }}
        >
          I Build Solutions That Scale
        </h1>
        <p className="mt-5 text-white" style={{ lineHeight: '1.8', fontSize: '18px' }}>
          As a passionate full-stack developer, I transform complex ideas into efficient, 
          user-friendly applications. With expertise in modern web technologies, I specialize 
          in creating robust systems that deliver exceptional performance and seamless user experiences.
        </p>
        <p className="text-white" style={{ lineHeight: '1.8', fontSize: '18px' }}>
          Every project is an opportunity to solve real-world problems through clean code, 
          innovative thinking, and attention to detail that makes digital products stand out.
        </p>
      </div>
      <div className="col-12 col-md-6 d-flex flex-column align-items-center gap-5">
        <div className="row w-100 justify-content-between stats-row">
          <div
            className="col-10 col-md-5 d-flex flex-column justify-content-center align-items-center border-bottom border-success text-center p-4"
            style={{ borderRadius: 20, background: 'rgba(0, 255, 0, 0.05)' }}
          >
            <span style={{ fontSize: 40, fontWeight: 700, color: '#00FF00' }}>5+</span>
            <p style={{ fontWeight: 600, fontSize: 18, color: 'white' }}>Completed Projects</p>
            <small style={{ color: '#b0aac0', fontSize: '14px' }}>Web Apps & Systems</small>
          </div>
          <div
            className="col-10 col-md-5 d-flex flex-column justify-content-center align-items-center border-bottom border-success text-center p-4"
            style={{ borderRadius: 20, background: 'rgba(0, 255, 0, 0.05)' }}
          >
            <span style={{ fontSize: 40, fontWeight: 700, color: '#00FF00' }}>10+</span>
            <p style={{ fontWeight: 600, fontSize: 18, color: 'white' }}>Satisfied Clients</p>
            <small style={{ color: '#b0aac0', fontSize: '14px' }}>Happy Customers</small>
          </div>
        </div>
        <div className="row w-100 justify-content-between stats-row">
          <div
            className="col-10 col-md-5 d-flex flex-column justify-content-center align-items-center border-bottom border-success text-center p-4"
            style={{ borderRadius: 20, background: 'rgba(0, 255, 0, 0.05)' }}
          >
            <span style={{ fontSize: 40, fontWeight: 700, color: '#00FF00' }}>3+</span>
            <p style={{ fontWeight: 600, fontSize: 18, color: 'white' }}>Years Coding</p>
            <small style={{ color: '#b0aac0', fontSize: '14px' }}>Continuous Learning</small>
          </div>
          <div
            className="col-10 col-md-5 d-flex flex-column justify-content-center align-items-center border-bottom border-success text-center p-4"
            style={{ borderRadius: 20, background: 'rgba(0, 255, 0, 0.05)' }}
          >
            <span style={{ fontSize: 40, fontWeight: 700, color: '#00FF00' }}>100%</span>
            <p style={{ fontWeight: 600, fontSize: 18, color: 'white' }}>Project Success</p>
            <small style={{ color: '#b0aac0', fontSize: '14px' }}>On-time Delivery</small>
          </div>
        </div>
      </div>
    </div>
  </section>
)